import { render, staticRenderFns } from "./DeviceFirmware.vue?vue&type=template&id=963f92aa&scoped=true"
import script from "./DeviceFirmware.vue?vue&type=script&lang=js"
export * from "./DeviceFirmware.vue?vue&type=script&lang=js"
import style0 from "./DeviceFirmware.vue?vue&type=style&index=0&id=963f92aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963f92aa",
  null
  
)

export default component.exports